var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"width":"100%","height":"100%","overflow":"hidden"}},[_c('faq-component',{attrs:{"info":_vm.info},on:{"projectChange":_vm.onProjectChange},model:{value:(_vm.infoData.Faq),callback:function ($$v) {_vm.$set(_vm.infoData, "Faq", $$v)},expression:"infoData.Faq"}}),_vm._v(" "),_c('vue-headful',{attrs:{"title":_vm.getPageTitle()}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0acca584","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./Content/src/views/FaqPage.vue
// module id = 851
// module chunks = 1